import Component from "../../lib/component";

export const PaneSlideFlipperConfig = {
  componentTypeKey: "PaneSlideFlipper",
  baseHtmlClass: "pane_slides__f",
  selector: ".pane_slides__f",

  datasetConfigKey: "pane_slide_flip__config",
};

export class PaneSlideFlipper extends Component {
  static get config() {
    return PaneSlideFlipperConfig;
  }

  constructor(id_or_element, paneSlide) {
    super({
      element: id_or_element,
      config: PaneSlideFlipper.config,
    });

    this.paneSlide = paneSlide;

    this.setDatasetConfig(PaneSlideFlipper.config.datasetConfigKey);

    this.targetId = this.getDatasetConfigValue("target_id");

    this.element.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick(event) {
    const paneSlideFlip = this.getPaneSlideFlip();
    if (paneSlideFlip) {
      event.preventDefault();
      paneSlideFlip.toggleFlip();
    }
  }

  render() {}

  getPaneSlideFlip() {
    return this.paneSlide.flipSides.find((flip) => {
      return flip.id === this.targetId;
    });
  }
}
